import { useState } from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const TopBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const scrollToContact = () => {
    const element = document.getElementById("cta-final");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="bg-primary text-primary-foreground overflow-hidden"
        >
          <div className="container flex items-center justify-between py-2.5 text-sm">
            <div className="flex-1 flex items-center justify-center gap-2 text-center">
              <span className="hidden sm:inline">
                Vai pedir proposta direto às locadoras?{" "}
              </span>
              <span className="font-medium">
                Fale com a Aceena antes — isso pode mudar sua decisão.
              </span>
              <button
                onClick={scrollToContact}
                className="ml-2 underline underline-offset-2 hover:text-aceena-green transition-colors font-semibold"
              >
                Falar com um especialista
              </button>
            </div>
            <button
              onClick={() => setIsVisible(false)}
              className="p-1 hover:bg-primary-foreground/10 rounded transition-colors ml-4"
              aria-label="Fechar banner"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
